import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {TeamService} from '@core/services/team.service';
import {LeagueService} from '@core/services/league.service';
import {LeagueSearchResult, SearchService, TeamSearchResult} from '@core/services/search.service';
import {StateService} from '@core/services/state.service';
import {UserService} from '@core/services/user.service';
import {FavouritesHomeComponent} from '@shared/components/favourites/favourites-home.component';
import {LinkService} from '@core/services/link.service';
import {HomeRoutes} from '@app/routes/home.routes';
import {CountryService} from '@core/services/country.service';
import {ActivatedRoute} from '@angular/router';
import {Sex} from '@shared/models/sex';
import {Subscription} from 'rxjs';
import {User} from '@shared/models/user';
import {UserHttpService} from '@api/http/user/user-http.service';
import {AppTeam} from '@shared/models/team';
import {AppLeague} from '@shared/models/league';

@Component({
  selector: 'app-my-teams-page',
  templateUrl: './my-teams-page.component.html',
  styleUrls: ['./my-teams-page.component.scss']
})
export class MyTeamsPageComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() styleMode: string = '';
  @Input() hasMargin: boolean = false;
  @ViewChild('favouritesHomeComponent') favouritesHomeComponent: FavouritesHomeComponent;
  teamsOfUser: TeamSearchResult[] = [];
  leaguesOfUser: LeagueSearchResult[] = [];
  teams: TeamSearchResult[] = [];
  leagues: LeagueSearchResult[] = [];
  searchString = '';
  searchLoading: Boolean = false;
  showSearchResults = false;
  onlyShowStatesAndLeagues: boolean = false;
  registerYourClubLink: string;
    public popularTeams: TeamSearchResult[] = [];
  public popularLeagues: LeagueSearchResult[] = [];
  private searchTimer: any = null;
  private itemLimit = 12;
  private user$: Subscription;
  private user: User;

  constructor( private appStateService: StateService,
               public userService: UserService,
               private teamService: TeamService,
               private leagueService: LeagueService,
               private searchService: SearchService,
               private userHttpService: UserHttpService,
               private route: ActivatedRoute ) { }

  ngOnInit() {
    if (StateService.isMobile()) {
      this.itemLimit = 8;
    }
    this.registerYourClubLink = LinkService.getHomeLink() + '/' + HomeRoutes.clubRegistration;
    this.loadTeams();
    this.loadLeagues();

    if (this.userService.currentUser) {
      this.loadTeamsAndLeagues();
    } else {
      this.user$ = this.userService.currentUserSubject.subscribe((user) => {
        if (user && user._id !== this.user?._id) {
          this.loadTeamsAndLeagues();
        }
      })
    }
  }

  private async loadTeamsAndLeagues(): Promise<void> {
    console.log('Login 3');
    const responseTeams = await this.userHttpService.getFavoriteTeams();
    if (responseTeams?.success) {
      this.teamsOfUser = responseTeams.data.map((team) => ({
        team: new AppTeam(team),
        link: ''
      } as TeamSearchResult));
      this.teamsOfUser.sort((a, b) =>
        a.team.name.localeCompare(b.team.name));
    }
    const responseLeagues = await this.userHttpService.getFavoriteLeagues();
    if (responseLeagues?.success) {
      this.leaguesOfUser = responseLeagues.data.map((league: any) => ({
        league: new AppLeague(league),
        link: '',
        state: ''
      } as LeagueSearchResult));
    }
  }

  public ngAfterViewInit(): void {
    const stateId = this.route.snapshot.paramMap.get('stateId');
    if (stateId) {
      this.favouritesHomeComponent.stateSelected(stateId);
      this.favouritesHomeComponent.onSexSelected(Sex.Male);
    }
  }

  public ngOnDestroy() {
    if (this.user$) {
      this.user$.unsubscribe();
    }
  }

  private async loadTeams() {
    this.teams = [];
    this.popularTeams = [];

    const teams = await this.teamService.fetchPopularTeams(CountryService.austrianId, this.itemLimit);
    if (teams == null) {
      return;
    }
    teams.forEach(team => {
      if (team != null) {
        this.popularTeams.push({team: team, link: ''});
      }
    });
  }

  private async loadLeagues() {
    this.leagues = [];
    this.popularLeagues = [];

    const leagues = await this.leagueService.fetchPopularLeagues(CountryService.austrianId, this.itemLimit);
    if (leagues == null) {
      return;
    }
    leagues.forEach(league => {
      if (league != null) {
        this.popularLeagues.push({league: league, link: '', state: ''});
      }
    });
  }

  public async searchStringChanged(event: object[]) {
    const searchStringIsDirty = this.searchString !== event.toString();
    if (this.searchLoading && searchStringIsDirty === false) {
      return;
    }
    this.searchLoading = true;

    if (this.searchTimer != null) {
      clearTimeout(this.searchTimer);
    }

    if (event.toString().length < 3) {
      this.searchString = event.toString();
      this.leagues = [];
      this.teams = [];
      this.searchLoading = false;
      this.showSearchResults = false;
      return;
    }

    this.searchTimer = setTimeout(async () => {
      this.searchString = event.toString();

      this.leagues = [];
      this.teams = [];

      const results = await this.searchService.searchTeamsAndLeagues(this.searchString);
      this.teams = results.teams.filter(entry => entry.link != null);
      this.leagues = results.leagues.filter(entry => entry.link != null);

      this.searchLoading = false;
      this.showSearchResults = this.teams.length !== 0 || this.leagues.length !== 0;

      this.favouritesHomeComponent.onGoBack(null);
    }, 500);
  }

  onStateAndLeagueSelectionChanged(somethingIsSelected: boolean) {
    this.onlyShowStatesAndLeagues = somethingIsSelected;
  }

}
